import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";


const departments = [
    { name: "परिचय", link: "#" },
    { name: "शोध परियोजनाएं", link: "#" },
    { name: "सेमीनार/सम्मेलन/कार्यशाला", link: "#" },
    { name: "शोधार्थी", link: "#" },
    { name: "उपलब्धियां", link: "#" },
    { name: "सम्पर्क", link: "#" },
];


export default function SaraswatiCivilizationResearchCenter() {


    const [showSidebar, setShowSidebar] = useState(true);
    const [activeContent, setActiveContent] = useState("परिचय");
    const [content, setContent] = useState("परिचय अनुभाग का चयन किया गया है।");


    const handleItemClick = (deptName) => {
        setActiveContent(deptName);
        setContent(`${deptName} अनुभाग का चयन किया गया है।`);
        setShowSidebar(false); // Sidebar को बंद करना
    };


    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle Button for Small Screens */}
            <button
                className="btn d-md-none m-2 shadow-sm text-white"
                onClick={() => setShowSidebar(!showSidebar)}
                style={{
                    backgroundColor: "#77236b",
                    borderColor: "#77236b"
                }}
            >
                ☰ मेनू
            </button>


            {/* Sidebar */}
            <aside className={` text-white p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none d-md-flex"} col-md-3`}>
                <h5 className="text-center fw-bold mb-3 text-dark">सरस्वती सभ्यता शोध केंद्र</h5>
                <div className="flex-grow-1 overflow-auto">
                    {departments.map((dept, index) => (
                        <p
                            key={index}
                            className={`mb-1 p-2 rounded shadow-sm small cursor-pointer transition-all ${activeContent === dept.name ? "text-white fw-bold" : "bg-white text-dark hover-effect"}`}
                            onClick={() => handleItemClick(dept.name)}
                            style={{
                                cursor: "pointer",
                                backgroundColor: activeContent === dept.name ? "#77236b" : "",
                            }}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>


            {/* Main Content */}
            <main className="flex-grow-1 p-3 bg-white shadow col-md-9" onClick={() => setShowSidebar(false)}>
                <h5 className="text-center mb-3" style={{ color: "#77236b" }}>{activeContent}</h5>
                <p style={{ color: "#77236b" }}>{content}</p>
            </main>
        </div>
    );
}